import FarmersNav from "@/components/FarmersNav";
import GeoTree from "@/pages/GeoTree";
import { fpPath } from "@/lib/site";

/**
 * FarmersGeoTree — Farmers Pulse variant of the unified geographic tree.
 *
 * Wraps <GeoTree /> with the FarmersNav sub-nav and preselects the four
 * farmer-relevant kinds so the drill-down leads with farms, farm shops,
 * food businesses and agricultural agencies — but still lets the user
 * add schools/observations back in with one tap.
 */
const FARMER_DEFAULT_KINDS = [
  "farm",
  "farm_website",
  "food_business",
  "gov_agency",
  "organization",
];

export default function FarmersGeoTree() {
  return (
    <GeoTree
      context="farmers"
      basePath={fpPath("/geo-tree")}
      brandLabel="Farmers Pulse"
      brandAccent="#B85F2A"
      defaultKinds={FARMER_DEFAULT_KINDS}
      navSlot={<div className="max-w-6xl mx-auto"><FarmersNav /></div>}
    />
  );
}
